"use client";

import { Provider } from "react-redux";
import { reduxStore } from "@/lib/redux";
import { PropsWithChildren } from "react";
import { ThemeProvider } from "styled-components";
import GlobalStyle from "@/styles/globals";
import { defaultTheme } from "@/styles/themes/default";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundaryProvider from "@/components/ErrorBoundaryProvider";

export function Providers({ children }: PropsWithChildren) {
  return (
    <ErrorBoundaryProvider>
      <ThemeProvider theme={defaultTheme}>
        <Provider store={reduxStore}>
          <ToastContainer closeOnClick draggable />
          <GlobalStyle />
          {children}
        </Provider>
      </ThemeProvider>
    </ErrorBoundaryProvider>
  );
}
